import { scaffolderPlugin } from '@backstage/plugin-scaffolder';
import { createScaffolderFieldExtension } from '@backstage/plugin-scaffolder-react';
import { GithubTeamPicker } from './GithubTeamPicker';

export const GithubTeamPickerFieldExtension = scaffolderPlugin.provide(
  createScaffolderFieldExtension({
    name: 'GithubTeamPicker',
    component: GithubTeamPicker,
  }),
);
